"use strict";

export const testUrl  = "gts.shmyth.cn" 		//测试
export const loadUrl  = "load.shmyth.cn"
export const licaiUrl = "licai.mingyitech.cn"	//利材
export const gtsUrl   = "gts.cheron.cn"			//卓隆
export const pzzUrl   = "pzzhzd.mingyitech.cn" 	//沛喆

export default {
	baseUrl: pzzUrl,
}